import { TextField } from 'mui-rff'
import { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { OnChange } from 'react-final-form-listeners'
import { InputAdornment, IconButton, Tooltip } from '@material-ui/core'
import { SettingsEthernet } from '@material-ui/icons'
import VariableMenu from 'components/variables/variablemenu'


export default function VariableAutofillTextField({ task, values, name, className, variant, label, disabled, type, save, preSaveHook }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const [showVariableMenu, setShowVariableMenu] = useState(false)

  const inputRef = useRef(null)

  function setContent(val) {
    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set
    nativeInputValueSetter.call(inputRef.current, val)
    inputRef.current.dispatchEvent(new Event('input', { bubbles: true }))
  }

  return <>
    <TextField className={className} variant={variant} name={name} label={label} disabled={disabled} type={type} inputRef={inputRef} InputProps={{
      type,
      endAdornment: <InputAdornment>
        {!disabled && <>
          <Tooltip title='Insert Variable'><IconButton
            style={{ padding: '0px 0px 0px 5px' }}
            aria-label="toggle password visibility"
            onClick={event => {
              setAnchorEl(event.currentTarget)
              setShowVariableMenu(true)
            }}
          >
            <SettingsEthernet />
          </IconButton></Tooltip>
          <VariableMenu task={task} showVariableMenu={showVariableMenu} setShowVariableMenu={setShowVariableMenu} setContent={val => setContent(`${inputRef.current.value} {{ ${val} }}`)} anchorEl={anchorEl} />
        </>}
      </InputAdornment>,
    }} />
    <OnChange name={name}>{val => {
      if (disabled) return
      if (preSaveHook) {
        const newVal = preSaveHook(val)
        if (val != newVal) {
          setTimeout(() => setContent(newVal), 100)
          return
        }
      }
      save(values)
    }}</OnChange></>

}

VariableAutofillTextField.propTypes = {
  task: PropTypes.object,
  values: PropTypes.object,
  name: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  save: PropTypes.func,
  preSaveHook: PropTypes.func,
}